import { Box } from '@mui/joy'
import { styled } from '@mui/joy/styles'

export const Text = styled(Box)(() => ({
    fontFamily:
        'Lato,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
}))
